export const PIP_UPDATE_FAILED_MESSAGE = "Couldn't update PIP status. Please try again.";

// Exit badges only appear when the exit date is within this many months from today
export const EXIT_NOTICE_WINDOW_MONTHS = 3;
export const EXIT_LABEL_RESIGNED = "Resigned";
export const EXIT_LABEL_CONTRACT_ENDS = "Contract ends";
